//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionExploreFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.56006 6.56L2.56006 21.41L17.4101 17.41L21.4101 2.56L6.56006 6.56ZM12.0001 14.25C11.5551 14.25 11.12 14.118 10.75 13.8708C10.38 13.6236 10.0916 13.2722 9.92133 12.861C9.75103 12.4499 9.70647 11.9975 9.79329 11.561C9.88011 11.1246 10.0944 10.7237 10.4091 10.409C10.7237 10.0943 11.1246 9.88005 11.5611 9.79323C11.9976 9.70641 12.45 9.75097 12.8611 9.92127C13.2722 10.0916 13.6236 10.38 13.8709 10.75C14.1181 11.12 14.2501 11.555 14.2501 12C14.2501 12.5967 14.013 13.169 13.591 13.591C13.1691 14.0129 12.5968 14.25 12.0001 14.25Z" fill="currentColor" /></svg>;
}
export default IconActionExploreFill;